import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "sidebarHeader" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "exit" }
const _hoisted_5 = { class: "sidebarBody" }
const _hoisted_6 = { class: "sidebarFooter" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Notes = _resolveComponent("Notes")!
  const _component_Tips = _resolveComponent("Tips")!
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("aside", {
      class: _normalizeClass(["sidebar", { collapsed: _ctx.collapseSidebar }]),
      "aria-label": "Sidebar"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.collapseSidebar)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_ctx.lessonTitle) + " // " + _toDisplayString(_ctx.section?.title), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.collapseSidebar)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
              }, "Exit"))
            : (_openBlock(), _createElementBlock("p", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
              }, "Exit Lesson"))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.showNotes)
          ? (_openBlock(), _createBlock(_component_Notes, {
              key: 0,
              onClose: _ctx.toggleNotes
            }, null, 8, ["onClose"]))
          : (_ctx.showTips)
            ? (_openBlock(), _createBlock(_component_Tips, {
                key: 1,
                onClose: _ctx.toggleTips
              }, null, 8, ["onClose"]))
            : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: _normalizeClass(["notes", { active: _ctx.showNotes }]),
          "aria-label": "Click to open notes",
          alt: "Notes page icon",
          title: "Notes",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleNotes && _ctx.toggleNotes(...args)))
        }, [
          _createVNode(_component_ion_icon, { name: "reader-outline" }),
          (!_ctx.collapseSidebar)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, "notes"))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("button", {
          class: _normalizeClass(["tips", { active: _ctx.showTips }]),
          "aria-label": "Click to open tips",
          alt: "Lightbult icon",
          title: "Tips",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleTips && _ctx.toggleTips(...args)))
        }, [
          _createVNode(_component_ion_icon, { name: "bulb-outline" }),
          (!_ctx.collapseSidebar)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, "tips"))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ], 2),
    _createElementVNode("button", {
      class: _normalizeClass(["collapseIcon", { collapsed: _ctx.collapseSidebar }]),
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
    }, [
      _createVNode(_component_ion_icon, { name: "chevron-back-outline" })
    ], 2)
  ], 64))
}